import type { NavigationItem } from '@/data/types';
import { resolveImagePath } from '@/utils/imageMap';

interface NavigationProps {
  items: NavigationItem[];
  onItemClick?: () => void;
}

export function Navigation({ items, onItemClick }: NavigationProps) {
  const newIconSrc = resolveImagePath('images/new.gif');

  return (
    <nav className="flex-1 px-4 py-6 overflow-y-auto">
      <ul className="space-y-2">
        {items.map((item, index) => (
          <li key={index}>
            <a
              href={item.href}
              target={item.target}
              rel={item.isExternal ? 'noopener noreferrer' : undefined}
              className="group flex items-center px-3 py-2 text-neutral-300 hover:text-white hover:bg-primary-600/20 rounded-md text-sm font-medium border-l-2 border-transparent hover:border-primary-500"
              onClick={onItemClick}
            >
              <span className="flex-1">{item.label}</span>
              {item.hasNewIcon && (
                <img
                  src={newIconSrc}
                  alt="new"
                  className="inline ml-2 opacity-80"
                />
              )}
            </a>
            {/* Add spacing after certain items */}
            {(item.label === 'Club History' || item.label === 'The Gun') && (
              <div className="h-2"></div>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
}